import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { ExpertsDataService, ExpertsColumnsService } from '../../../services';
import { Experts, ExpertsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-expert-details',
  templateUrl: './expert-details.component.html',
  styleUrls: ['./expert-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ExpertDetailsComponent implements OnInit, OnDestroy {

  public expert: Experts = {};
  public experts: Experts[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private expertsDataService: ExpertsDataService,
    private expertsColumnsService: ExpertsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Expert - Details');
        this.getExpert(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.expert !== 'undefined') {
      this.expert = this.dynamicDialogConfig.data.expert;
    }
    this.columns = this.expertsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getExpert(id: number): void {
    this.isLoading = true;
    this.expertsDataService.getExpert(id).subscribe((response: Experts|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.expert = response;
      }
    });
  }

  list() {
    this.router.navigate(['/experts']);
  }

  add() {
    this.router.navigate(['/experts/add']);
  }

  edit() {
    this.router.navigate(['/experts/edit/' + this.expert.id]);
  }

}
@Component({
  selector: 'app-expert-details',
  templateUrl: './expert-details.component.html',
  styleUrls: ['./expert-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogExpertDetailsComponent extends ExpertDetailsComponent {
}

